import type { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box } from '@atlaskit/primitives';
import { useToken } from '../../../Flow/ConsentContextProvider';
import { filterScopes, scopeDescriptions } from './scopes';

const headers = defineMessages({
  header: {
    id: 'partnercentral.permissions.header',
    defaultMessage: '{appName} will be able to',
    description: 'Header describing Partner Central permissions',
  },
});

const PermissionsBullets: FunctionComponent = () => {
  const { scopes, clientName } = useToken();
  return (
    <Box>
      <FormattedMessage
        {...headers.header}
        values={{
          appName: <strong>{clientName}</strong>,
        }}
      />
      <ul>
        {filterScopes(scopes).map((scope) => (
          <li key={scope}>
            {scope in scopeDescriptions ? (
              <FormattedMessage {...scopeDescriptions[scope]} />
            ) : (
              <code>{scope}</code>
            )}
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default PermissionsBullets;
